<div class="filters px-16" [class.filters--stacked]="shouldStackSearchBar" *appVar="viewUpdate$ | async" data-cy="Quote filters">
  <div class="search-field">
    <ion-icon name="search-outline"></ion-icon>
    <ion-input [formControl]="searchControl" [placeholder]="'quote.filters.search' | translate" data-cy="Quote search input"></ion-input>
    <ion-button
      *ngIf="(searchControl.value ?? '').length"
      fill="clear"
      class="clear-search-button"
      (click)="clearSearch()"
      data-cy="Clear quote search input"
      mode="ios"
    >
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>
  <div *ngIf="configuration.toggle || configuration.filters" class="filters-actions">
    <ion-item class="ion-no-padding" lines="none">
      <ng-container *ngIf="configuration.toggle">
        <ion-label class="fs-13 font-medium filters-text">{{ toggleLabel | translate }}</ion-label>
        <ion-toggle slot="start" [formControl]="form.controls.toggle" data-cy="Owned quotes filter"></ion-toggle>
      </ng-container>
    </ion-item>
    <ion-button
      *ngIf="configuration.filters"
      fill="clear"
      class="fs-13 filters-text filter-button"
      [class.filter-button--active]="hasActiveModalFilters"
      (click)="openFiltersModal()"
      data-cy="Open quotes filters modal"
      mode="ios"
    >
      <ion-icon slot="start" type="" name="funnel"></ion-icon>
      {{ 'quote.filters.filter' | translate }}
      <span *ngIf="hasActiveModalFilters" class="filter-button__dot" aria-hidden="true"></span>
    </ion-button>
  </div>
</div>
